<style scoped>
.el-col-5 {
  width: 30%;
}
/deep/ .el-dialog {
  background: #f1f1f1;
  -webkit-box-sizing: border-box;
}
/deep/ .el-dialog__body {
  padding: 20px 20px;
}
.teble-class {
  width: 100%;
  text-align: center;
}
.teble-class tr {
  height: 35px;
  text-align: center;
}
/deep/ .el-table .hidden-row {
  display: none;
}
.ipt-sty{
  /* flex: 1; */
  width: 70% !important;
  margin-left: 5px;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">所属公司：</div>
          <el-select  v-model="page.tenantGuid" placeholder="请选择" style="width: 64%" filterable>
            <el-option v-for="item in tenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">参数名称：</div>
          <el-input v-model="page.paramName" placeholder="参数名称" style="width: 64%"></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">参数编码：</div>
          <el-input v-model="page.code" placeholder="参数编码" style="width: 64%"></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">参数用途：</div>
          <el-input v-model="page.paramPurpose" placeholder="参数用途" style="width: 64%"></el-input>
        </el-col>
        <el-col :span="24" style="margin-top:10px;text-align:right;">
          <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="medium" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="add(1, '')">添加参数</el-button>
      <el-button size="medium" type="danger" @click="getDeleteData(1, '')">批量删除</el-button>
    </div>
    <div class="back-color-fff" style="padding: 16px">
      <el-table :data="tableData" @selection-change="handleSelectionChange" border style="width: 100%">
        <el-table-column type="selection" width="60" header-align="center" align="center"></el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="tenantName" label="所属公司" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="code" label="参数编码" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="codeName" label="参数用途" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="name" label="参数名称" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="parameterValue" label="参数值" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="updateUserName" label="操作人" header-align="center" align="center"></el-table-column>
        <el-table-column width="170" prop="updateTime" label="操作时间" sortable header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.updateTime | getTimeDate }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="add(3, scope.row)">复制 | </a>
            <a class="txt-color" @click="add(2, scope.row)">编辑 | </a>
            <a class="txt-color-red" @click="getDeleteData(2, scope.row)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination class="pt pb back-color-fff" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 100, 200]" :current-page="page.pageIndex" :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
    </el-pagination>
    <section v-if="dialogFormVisible">
      <el-dialog :title="textTitle" :visible.sync="dialogFormVisible" fullscreen>
        <el-form ref="ruleForm" label-width="100px" :label-position="right" class="demo-ruleForm">
          <div class="search-area t-left">
            <h3>基本信息</h3>
            <el-row :gutter="24">
              <el-col :span="8">
                <div class="search-area-div required">所属公司：</div>
                  <el-select v-if="textTitle == '编辑参数'" class="ipt-sty" v-model="dto.tenantGuid" placeholder="请选择" filterable>
                    <el-option v-for="item in tenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
                    </el-option>
                  </el-select>
                  <el-select v-else class="ipt-sty" filterable v-model="dto.tenantGuid" multiple placeholder="请选择">
                    <el-option v-for="item in tenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
                    </el-option>
                  </el-select>
               
              </el-col>
              <el-col :span="8">
                <div class="search-area-div">参数编码：</div>
                <el-input class="ipt-sty" v-model="dto.code" placeholder="参数编码"></el-input>
              </el-col>
              <el-col :span="8">
                <div class="search-area-div required">参数用途：</div>
                <el-input class="ipt-sty" v-model="dto.codeName" placeholder="参数用途"></el-input>
              </el-col>
            </el-row>
          </div>
          <div class="back-color-fff mt15 t-left" style="padding: 16px">
            <h3>参数设置</h3>
            <el-button icon="el-icon-plus" size="medium" type="info" @click="addRow()" v-if="dto.codeName != '打卡距离'">添加参数</el-button>
            <el-table :data="dto.child" border style="width: 100%; margin-top: 15px" :row-class-name="tableRowClassName">
              <!-- <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope"> 
              {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
            </template>
          </el-table-column>  -->
              <el-table-column prop="name" label="参数名称" header-align="center" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.name" placeholder="必填，请输入内容"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="parameterValue" label="参数值" header-align="center" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.parameterValue" placeholder="必填，请输入内容"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="orderNum" label="排序" header-align="center" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.orderNum" placeholder="请输入内容"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" header-align="center" align="center">
                <template slot-scope="scope">
                  <a class="txt-color-red" @click="delForm(scope.$index, scope.row)">删除</a>
                </template>
              </el-table-column>
            </el-table>
            <!-- <table class="teble-class">
            <tr> 
            <td>参数名称</td>
            <td>参数值</td>
            <td>排序</td>
            <td>操作</td>
            </tr>
            <tr v-for="(ch,index) in dto.child" v-if="dto.child.length > 0 && ch.isDeleted != 'Y'"> 
            <td><el-input v-model="ch.name" placeholder="必填，请输入内容"></el-input></td>
            <td><el-input v-model="ch.parameterValue" placeholder="必填，请输入内容"></el-input></td>
            <td><el-input v-model="ch.orderNum" placeholder="请输入内容"></el-input></td>
            <td><a class="txt-color-red" @click="delForm(index,ch)">删除</a></td>
            </tr>
            <tr v-else><td  colspan="4">暂无数据！</td></tr>
        </table> -->
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button plain size="medium" @click="dialogFormVisible = false">取消</el-button>
          <el-button size="medium" type="info" v-if="textTitle == '添加参数'" @click="submitForm('ruleForm')">确定</el-button>
          <el-button size="medium" type="info" v-else @click="upDateForm()">确定</el-button>
        </div>
      </el-dialog>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input: '',
      textTitle: '',
      right: '',
      dialogVisible: false,
      dialogFormVisible: false,
      formLabelWidth: '120px',
      ruleForm: {
        guid: '',
        typeintroduction: '',
        datavalue: '',
        dataintroduction: '',
        dataseqno: '',
        state: 'Y',
      },
      sh: false,
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        code: '',
        paramName: '',
        paramPurpose: ''  //参数用途
      },
      dto: {
        tenantGuid: '',
        codeName: '',
        code: '',
        child: [
          {
            guid: '',
            name: '',
            parameterValue: '',
            orderNum: '',
            isDeleted: '',
          },
        ],
      },
      tableData: [],
      tableData1: [],
      multipleSelection: [],
      repositoryTypeList: [],
      tenantList: [],
    };
  },
  created() {
    // 列表
    this.getData(false);
    this.getTenantList();
  },
  methods: {
    addRow() {
      let self = this;
      let item = {
        guid: '',
        name: '',
        parameterValue: '',
        orderNum: '',
        isDeleted: '',
      };
      self.dto.child.push(item);
    },
    tableRowClassName(row, index) {
      if (row.row && row.row.isDeleted == 'Y') {
        return 'hidden-row';
      }
      return '';
    },
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        paramName: '',
      };
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.api.postJson(`/${serverConfig.msConfigureService}/sysparameter/data/get-list-grp`, this.page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getTenantList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: [...this.$getValueListByKey('上游客户分类'), '9901'],
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function (item) {
        let items = {
          tenantGuid: item.tenantGuid,
          code: item.code,
        };
        //item 就是当日按循环到的对象
        self.multipleSelection.push(items);
      });
    },
    getDeleteData(flg, row) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelection.length == 0) {
          self.$message.error('请勾选数据！');
          return;
        }
      } else {
        self.multipleSelection = [];
        let item = {
          tenantGuid: row.tenantGuid,
          code: row.code,
        };
        self.multipleSelection.push(item);
      }
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api
            .postJson(`/${serverConfig.msConfigureService}/sysparameter/data/delete-grp`, self.multipleSelection)
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.multipleSelection = [];
                self.$message.success('删除业务参数成功');
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    add(flg, row) {
      let self = this;
      if (flg == 1) {
        self.textTitle = '添加参数';
        self.dto.guid = '';
        self.dto.tenantGuid = [];
        self.dto.codeName = '';
        self.dto.code = '';
        self.dto.child = [
          {
            guid: '',
            name: '',
            parameterValue: '',
            orderNum: '',
            isDeleted: '',
          },
        ];
        self.$forceUpdate();
        self.dialogFormVisible = true;

      } else if (flg == 2) {
        self.textTitle = '编辑参数';

        self.getDetailGrpData(row.tenantGuid, row.code);
      } else {
        self.dto.tenantGuid = '';
        self.textTitle = '添加参数';

        self.getDetailGrpData(row.tenantGuid, row.code);
      }
    },
    getDetailGrpData(tenantGuid, code) {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msConfigureService}/sysparameter/data/get-detail-grp?tenantGuid=` +
          tenantGuid +
          '&code=' +
          code,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data != null) {
              self.dto.tenantGuid = res.data.data[0].tenantGuid;
              self.dto.codeName = res.data.data[0].codeName;
              self.dto.code = res.data.data[0].code;
              self.dto.child = res.data.data;
              self.sh = true;
            }
            self.dialogFormVisible = true;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    submitForm() {
      let self = this;
      if (self.dto.tenantGuid == '' || self.dto.tenantGuid == null) {
        self.$message.error('请选择所属公司！');
        return;
      }
      if (self.dto.codeName == '' || self.dto.codeName == null) {
        self.$message.error('请输入参数用途！');
        return;
      }
      if (self.dto.child != null) {
        self.dto.child.forEach(function (i) {
          i.tenantGuid = self.dto.tenantGuid;
        });
      }
      for (var i = 0; i < self.dto.child.length; i++) {
        if (self.dto.child[i].name == '' || self.dto.child[i].name == null) {
          self.$message.error('请输入参数名称！');
          return;
        }
        if (self.dto.child[i].parameterValue == '' || self.dto.child[i].parameterValue == null) {
          self.$message.error('请输入参数值！');
          return;
        }
      }
      let tenantGuids = self.dto.tenantGuid;
      let promise = [];

      tenantGuids.forEach((item) => {
        promise.push({
          tenantGuid: item,
          codeName: self.dto.codeName,
          code: self.dto.code,
          parameters: self.dto.child,
        });
      });
      self.api.postJson(`/${serverConfig.msConfigureService}/sysparameter/data/add-grp`, promise).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogFormVisible = false;
          self.$message.success('编辑业务参数成功');
          self.getData(true);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    upDateForm() {
      let self = this;
      if (self.dto.tenantGuid == '' || self.dto.tenantGuid == null) {
        self.$message.error('请选择所属公司！');
        return;
      }
      if (self.dto.codeName == '' || self.dto.codeName == null) {
        self.$message.error('请输入参数用途！');
        return;
      }
      if (self.dto.child != null) {
        self.dto.child.forEach(function (i) {
          i.tenantGuid = self.dto.tenantGuid;
        });
      }
      for (var i = 0; i < self.dto.child.length; i++) {
        if (self.dto.child[i].name == '' || self.dto.child[i].name == null) {
          self.$message.error('请输入参数名称！');
          return;
        }
        if (self.dto.child[i].parameterValue == '' || self.dto.child[i].parameterValue == null) {
          self.$message.error('请输入参数值！');
          return;
        }
      }
      let promise = {
        // guid: self.dto.guid,
        tenantGuid: self.dto.tenantGuid,
        codeName: self.dto.codeName,
        code: self.dto.code,
        child: self.dto.child,
      };
      self.api.put(`/${serverConfig.msConfigureService}/sysparameter/data/update-grp`, promise).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogFormVisible = false;
          self.$message.success('编辑业务参数成功');
          self.getData(true);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    delForm(index, row) {
      let self = this;
      console.log(index, row);
      if (row.guid == '') {
        self.dto.child.splice(index, 1);
      } else {
        row.isDeleted = 'Y';
        self.tableRowClassName(row, index);
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script>
